export const CEF_SHARP_OBJECT_UPDATE_ERROR_PATTERN =
  /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:4/;

export const COMMON_IGNORED_SENTRY_ERRORS = [
  /Apollo signout triggered/,
  /UserAlreadyAuthenticatedException/,
  /Not authenticated/,
  /Token expired/,
  /NotAuthorizedException: Incorrect username or password\./,
  /NotAuthorizedException: Password attempts exceeded/,
  /UserNotFoundException: User does not exist\./,
  /CodeMismatchException: Invalid verification code provided, please try again\./,
  /UserUnAuthenticatedException: User needs to be authenticated to call this API\./,
  /NotAuthorizedException: User is disabled\./,
  CEF_SHARP_OBJECT_UPDATE_ERROR_PATTERN,
  /undefined is not an object \(evaluating '.*\.containers'\)/,
  /handle-ios-locking/,
  /Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
];

const PUBLIC_NETWORK_ERROR_PATTERNS = [
  /TypeError: Failed to fetch \((api|api-qa)\.retainerclub\.com\)/,
  /TypeError: Load failed \((api|api-qa)\.retainerclub\.com\)/,
  /Failed to fetch \((api|api-qa)\.retainerclub\.com\)/,
  /Load failed \((api|api-qa)\.retainerclub\.com\)/,
  /ApolloError: Failed to fetch \((api|api-qa)\.retainerclub\.com\)/,
  /ApolloError: Load failed \((api|api-qa)\.retainerclub\.com\)/,
  /NetworkError: A network error has occurred\./,
  /TypeError: NetworkError when attempting to fetch resource\. \((api|api-qa)\.retainerclub\.com\)/,
];

const PUBLIC_ROUTE_PATTERNS = [
  /^https:\/\/shop\.retainerclub\.com\/($|signin|forgot-password|reset-password|onboarding\/get-started|shop)([/?#].*)?$/,
  /^https:\/\/s-qa\.retainerclub\.com\/($|signin|forgot-password|reset-password|onboarding\/get-started|shop)([/?#].*)?$/,
  /^https:\/\/locator\.retainerclub\.com([/?#].*)?$/,
  /^https:\/\/l-qa\.retainerclub\.com([/?#].*)?$/,
];

const CUSTOMER_CART_ITEM_DELETE_NOT_FOUND_PATTERN =
  /GraphQL error in destroyCartItem[\s\S]*Message: Cart item not found[\s\S]*Path: destroyCartItem/;

const VERSION_CHECK_AUTH_ERROR_PATTERNS = [
  /Unknown: An unknown error has occurred\./,
  /An unknown error has occurred\./,
  /NotAuthorizedException: Invalid login token\. Couldn't verify signed token\./,
];

const VERSION_CHECK_CONSOLE_PATTERN = /^\[VersionCheck\] Error checking version:/;

const VERSION_CHECK_FRAME_PATTERN =
  /(?:^|\/)useVersionCheck(?:\.[^/?#]+)?(?:[?#].*)?$/;

const APOLLO_STATUS_200_WARNING_PATTERN = /^Server Application error: 200$/;

function eventMessages(event, hint) {
  const messages = [
    event?.message,
    event?.logentry?.message,
    hint?.originalException?.message,
    typeof hint?.originalException === 'string' ? hint.originalException : undefined,
  ];

  for (const exception of event?.exception?.values || []) {
    messages.push(exception?.value);
  }

  for (const argument of event?.extra?.arguments || []) {
    messages.push(typeof argument === 'string' ? argument : argument?.message);
  }

  return messages.filter(Boolean);
}

function eventFrames(event) {
  return (event?.exception?.values || []).flatMap(
    (exception) => exception?.stacktrace?.frames || [],
  );
}

function eventUrl(event) {
  return event?.request?.url || event?.tags?.url || globalThis.location?.href || '';
}

function hasKnownUser(event) {
  return Boolean(event?.user?.id || event?.user?.email || event?.user?.username);
}

function matchesAnyPattern(value, patterns) {
  return patterns.some((pattern) => pattern.test(value));
}

function isApolloStatus200Warning(event, messages) {
  const args = event?.extra?.arguments || [];

  return (
    messages.some((message) => APOLLO_STATUS_200_WARNING_PATTERN.test(message)) ||
    (args[0] === 'Server Application error:' && args[1] === 200)
  );
}

export function filterSentryEvent(event, hint) {
  const messages = eventMessages(event, hint);
  const frames = eventFrames(event);

  if (isApolloStatus200Warning(event, messages)) {
    return null;
  }

  if (
    messages.some((message) =>
      CUSTOMER_CART_ITEM_DELETE_NOT_FOUND_PATTERN.test(message),
    )
  ) {
    return null;
  }

  if (
    messages.some((message) =>
      matchesAnyPattern(message, VERSION_CHECK_AUTH_ERROR_PATTERNS),
    ) &&
    (frames.some((frame) => VERSION_CHECK_FRAME_PATTERN.test(frame?.filename || '')) ||
      messages.some((message) => VERSION_CHECK_CONSOLE_PATTERN.test(message)))
  ) {
    return null;
  }

  if (
    !hasKnownUser(event) &&
    matchesAnyPattern(eventUrl(event), PUBLIC_ROUTE_PATTERNS) &&
    messages.some((message) => matchesAnyPattern(message, PUBLIC_NETWORK_ERROR_PATTERNS))
  ) {
    return null;
  }

  return event;
}
